import React from 'react';
export const CloseFill = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 0C4.47715 2.41411e-07 0 4.47715 0 10C2.41411e-07 15.5229 4.47715 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47715 15.5229 4.37114e-07 10 4.37114e-07V0ZM12.71 11.29C13.1021 11.6789 13.1047 12.3121 12.7158 12.7042C12.7139 12.7061 12.7119 12.7081 12.71 12.71C12.3211 13.1021 11.6879 13.1047 11.2958 12.7158C11.2939 12.7139 11.2919 12.7119 11.29 12.71L10 11.41L8.71 12.71C8.32108 13.1021 7.68792 13.1047 7.2958 12.7158C7.29386 12.7139 7.29193 12.7119 7.29 12.71C6.89788 12.3211 6.89529 11.6879 7.28421 11.2958C7.28613 11.2939 7.28806 11.2919 7.29 11.29L8.59 10L7.29 8.71C6.89788 8.31788 6.89788 7.68212 7.29 7.29C7.68213 6.89788 8.31788 6.89788 8.71 7.29L10 8.59L11.29 7.29C11.6821 6.89788 12.3179 6.89788 12.71 7.29C13.1021 7.68212 13.1021 8.31788 12.71 8.71L11.41 10L12.71 11.29Z",
  fill: "currentColor"
}));